module.exports = __webpack_public_path__ + "img/form.2afc73ce.svg";